export interface ScoreResult {
  stars: 1 | 2 | 3
  xpEarned: number
}

// Race-It star thresholds: ≤30s = 3★, ≤60s = 2★, else 1★.
export function calculateScore(
  elapsedMs: number,
  xpReward: { oneStar: number; twoStar: number; threeStar: number }
): ScoreResult {
  if (elapsedMs <= 30_000) return { stars: 3, xpEarned: xpReward.threeStar }
  if (elapsedMs <= 60_000) return { stars: 2, xpEarned: xpReward.twoStar }
  return { stars: 1, xpEarned: xpReward.oneStar }
}
